
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","data-icon":"bookmark","data-prefix":"fad","viewBox":"0 0 384 512","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"fa-group"},[_c('path',{staticClass:"fa-secondary",attrs:{"d":"M384 48v464L192 400 0 512V48A48 48 0 0148 0h32v326.11a16 16 0 0023.16 14.31L192 296l88.84 44.42A16 16 0 00304 326.11V0h32a48 48 0 0148 48z"}}),_c('path',{staticClass:"fa-primary",attrs:{"d":"M304 0v326.11a16 16 0 01-23.16 14.31L192 296l-88.84 44.42A16 16 0 0180 326.11V0z"}})])])
          )
        }
      }
    